export const LOAD_ADMIN_USERS = "LOAD_ADMIN_USERS";

export const LOAD_ADMINUSERS_SUCCESS = "LOAD_ADMINUSERS_SUCCESS";

export const CREATE_ADMINUSER_SUCCESS = "CREATE_ADMINUSER_SUCCESS";

export const SAVE_ADMINUSER_SUCCESS = "SAVE_ADMINUSER_SUCCESS";

export const DELETE_ADMINUSER_SUCCESS = "DELETE_ADMINUSER_SUCCESS";

export const LOAD_ADMINUSER_DETAIL_SUCCESS = "LOAD_ADMINUSER_DETAIL_SUCCESS";

export const CREATE_ADMINUSER = "CREATE_ADMINUSER";
export const SAVE_ADMINUSER = "CREATE_ADMINUSER";
